import {Component, Input, OnInit, Output, EventEmitter}        from '@angular/core';
declare var $: any;

import {Sucursal} from '../sucursal/sucursal';
import {Ubicacion} from '../ubicacion/ubicacion';

import {UbicacionService} from './ubicacion.service';
import {PermisoService} from '../permiso/permiso.service';
import {LoginService} from '../login/login.service';

import * as _ from "lodash";

@Component({
    selector: 'ubicacion',
    template: require('../../app/ubicacion/ubicacion.component.html'),
    styles: [require('../../app/ubicacion/ubicacion.component.css')]
})
export class UbicacionComponent implements OnInit {
    @Input() sucursal: Sucursal;
    @Input() ubicacion: Ubicacion;
    active: any;
    deshabilitar: boolean;
    @Output() permisos = new EventEmitter();
    usuario: any;

    constructor(private ubicacionService: UbicacionService,
                private permisoService: PermisoService,
                private loginService: LoginService,) {
    }

    ngOnInit() {
        this.ubicacion = new Ubicacion();
        this.active = true;

        //Pedir permisos
        this.permisoService.getPermiso("ubicacion").subscribe(permisos => {
            var respuesta = new Map();
            for (let permiso of permisos.tipoPermiso) {
                respuesta.set(permiso.descripcion, true);
            }
            this.permisos.emit({permisos: respuesta});
        })
        this.usuario = this.loginService.getDecodeToken();
    }

    closeModal() {
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Inicializo variables
        if (this.ubicacion._id != undefined && this.ubicacion._id != "" && this.ubicacion._id != null)
            this.ubicacionService.getUbicacion(this.ubicacion._id).subscribe((ubicacion) => {
                this.ubicacion.descripcion = ubicacion.descripcion;
                this.ubicacion.area = ubicacion.area;
            });
        //this.ubicacion = new Ubicacion();
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Ocultar modal
        $("#modalUbicacion").modal("hide");
        $("#confirmacionUbicacion").modal("hide");
    }

    eliminar() {
        //Busco ubicacion
        this.ubicacionService
            .getUbicacion(this.ubicacion._id)
            .subscribe(ubicacion => {
                this.ubicacionService.delete(ubicacion).subscribe(
                    (ubicacion) => {
                        for (let ubicacionL of this.sucursal.ubicaciones) {
                            if (ubicacionL._id == ubicacion._id) {
                                ubicacionL.estado = ubicacion.estado;
                                if (!ubicacion.estado)
                                    for (let nodo of ubicacionL.nodos) {
                                        nodo.estado = ubicacion.estado;
                                        for (let sensor of nodo.sensores_id) {
                                            sensor.estado = ubicacionL.estado;
                                            for (let alarma of sensor.alarmas) {
                                                alarma.estado = ubicacion.estado;
                                                for (let aviso of alarma.avisosLista) {
                                                    aviso.estado = ubicacion.estado;
                                                }
                                            }
                                        }
                                    }
                                break;
                            }
                        }
                    });
                $("#confirmacionUbicacion").modal("hide");

            });
    }

    save() {
        //Determino operacion
        var operacion = "";
        if (this.ubicacion._id == "" || this.ubicacion._id == undefined)
            operacion = "agregar";
        else
            operacion = "modificar";
        //Elimino redundancia
        this.ubicacion.sucursal_id = this.sucursal._id;
        var ubicacionSimplificada = _.cloneDeep(this.ubicacion);
        delete ubicacionSimplificada.nodos;
        //Guardo
        this.ubicacionService
            .save(ubicacionSimplificada)
            .subscribe((ubicacion) => {
                //Inicializo variables
                this.ubicacion = ubicacion;
                //Actualizo listas
                if (operacion == "agregar")
                    this.sucursal.ubicaciones.push(ubicacion);
                else {
                    this.ubicacion.descripcion = ubicacion.descripcion;
                    this.ubicacion.area = ubicacion.area;

                    for (let ubicacionL of this.sucursal.ubicaciones) {
                        if (ubicacionL._id == ubicacion._id) {
                            ubicacionL.descripcion = ubicacion.descripcion;
                            ubicacionL.area = ubicacion.area;
                            break;
                        }
                    }
                }
                //Ocultar modal
                $("#modalUbicacion").modal("hide");
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
            })
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/ubicacion/ubicacion.component.ts